<template>
    <div v-show="!shouldShowWaiverInput(index)" class="text-right"
         @click="showWaiverInput(index)">
        {{ Number(entry.waived_amount).toLocaleString() }}
    </div>
    <div v-show="shouldShowWaiverInput(index)" class="text-right">
        <input type="text"
               autocomplete="off"
               title="Waiver"
               :ref="`waiver_input_${index}`"
               v-model="entry.waived_amount"
               @focusout="hideWaiverInput"
               @keyup.enter="hideWaiverInput"
               class="text-right form-control inline-block"/>
    </div>
    <small class="invalid-feedback d-block"
           v-show="error !== ''">
        {{ error || '' }}
    </small>
</template>

<script>
import {ref} from "vue";

export default {
    props: {
        entry: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
        hasWaiverEditPermission: {
            type: Boolean,
            required: false,
            default: false,
        },
        error: {
            type: String,
            required: false,
        },
    },
    setup() {
        return {
            waiverInputIndexToShow: ref(null),
        }
    },
    methods: {
        shouldShowWaiverInput(index) {
            return this.waiverInputIndexToShow === index && this.hasWaiverEditPermission
        },
        showWaiverInput(index) {
            this.waiverInputIndexToShow = index
            this.$nextTick(() => {
                const inputElem = this.$refs[`waiver_input_${index}`]
                inputElem.value = inputElem.value > 0 ? Number(inputElem.value).toString() : ''
                inputElem.focus()
            })
        },
        hideWaiverInput() {
            this.waiverInputIndexToShow = null
        },
    }
}
</script>

<style scoped>

</style>
